import {storage} from "./config";
import {ref, listAll, getDownloadURL, ListResult} from "firebase/storage"

export const readDirectoryFilesUrls = async (path: string): Promise<string[]> => {
    const storageRef = ref(storage, path)
    const listResult: ListResult = await listAll(storageRef);
    return Promise.all(listResult.items.map(getDownloadURL));
}